"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utilities_1 = require("./helpers/utilities");
var lazyLoader_1 = __importDefault(require("./modules/lazyLoader"));
var primaryHero_1 = __importDefault(require("./modules/primaryHero"));
var featuredCollection_1 = __importDefault(require("./modules/featuredCollection"));
var collectionGrid_1 = __importDefault(require("./modules/collectionGrid"));
var recentlyViewed_1 = __importDefault(require("./modules/recentlyViewed"));
var addToBag_1 = __importDefault(require("./modules/addToBag"));
var miniBasket_1 = __importDefault(require("./modules/miniBasket"));
var gallery_1 = __importDefault(require("./modules/gallery"));
var productOptions_1 = __importDefault(require("./modules/productOptions"));
var filters_1 = __importDefault(require("./modules/filters"));
var productGroup_1 = __importDefault(require("./helpers/productGroup"));
var productColors_1 = __importDefault(require("./modules/productColors"));
var quantity_1 = __importDefault(require("./modules/quantity"));
var overlay_1 = __importDefault(require("./modules/overlay"));
var btnCheckout_1 = __importDefault(require("./modules/btnCheckout"));
var menuSlideout_1 = __importDefault(require("./modules/menuSlideout"));
var menuDropdown_1 = __importDefault(require("./modules/menuDropdown"));
var lineItemTable_1 = __importDefault(require("./modules/lineItemTable"));
var login_1 = __importDefault(require("./modules/login"));
var cookieConsent_1 = __importDefault(require("./modules/cookieConsent"));
var accordion_1 = __importDefault(require("./modules/accordion"));
var searchBar_1 = __importDefault(require("./modules/searchBar"));
var modal_1 = __importDefault(require("./modules/modal"));
var currencyPicker_1 = __importDefault(require("./modules/currencyPicker"));
var article_1 = __importDefault(require("./modules/article"));
var variantSwitch_1 = __importDefault(require("./modules/variantSwitch"));
var metred_1 = __importDefault(require("./modules/metred"));
var customRug_1 = __importDefault(require("./modules/customRug"));
var App = /** @class */ (function () {
    function App() {
        this.resize = (0, utilities_1.debounce)(function (node) {
            accordion_1.default.load();
        }, 250);
    }
    App.prototype.init = function () {
        document.addEventListener('DOMContentLoaded', this.load);
        document.addEventListener('resize', this.resize);
    };
    App.prototype.load = function () {
        console.log('app is loading');
        accordion_1.default.init();
        lazyLoader_1.default.init();
        overlay_1.default.init();
        primaryHero_1.default.init();
        featuredCollection_1.default.init();
        recentlyViewed_1.default.init();
        collectionGrid_1.default.init();
        gallery_1.default.init();
        addToBag_1.default.init();
        productOptions_1.default.init();
        miniBasket_1.default.init();
        filters_1.default.init();
        quantity_1.default.init();
        btnCheckout_1.default.init();
        menuSlideout_1.default.init();
        menuDropdown_1.default.init();
        productGroup_1.default.init();
        productColors_1.default.init();
        login_1.default.init();
        lineItemTable_1.default.init();
        cookieConsent_1.default.init();
        searchBar_1.default.init();
        modal_1.default.init();
        currencyPicker_1.default.init();
        article_1.default.init();
        variantSwitch_1.default.init();
        metred_1.default.init();
        customRug_1.default.init();
        // qf cookie fix
        // $(".cookie-button.cookie-consent__close").on("click", function(){
        //   $(".cookie-consent").addClass('hide');
        //   window.localStorage.setItem('hasConsent', '');
        // })
        var cookieButton = document.querySelector('.cookie-button.cookie-consent__close');
        if (cookieButton) {
            cookieButton.addEventListener('click', function () {
                var _a;
                (_a = document.querySelector('.cookie-consent')) === null || _a === void 0 ? void 0 : _a.classList.add('hide');
                window.localStorage.setItem('hasConsent', '');
            });
        }
    };
    return App;
}());
exports.default = App;
